import React from 'react';
import { Formik } from 'formik';
import { ClassicButton } from 'modules/shared-ui/components';
import {
    InputControl,
    EmailInputControl,
    PhoneInputControl,
    DatePickerControl,
    RadioInputControl,
} from 'modules/shared-form';

import { CivilityList } from 'modules/shared/utils';
import { PersonalInfoFormProps, PersonalInfo } from './personal-info-form-type';

import styles from './personal-info-form-component.module.css';

export const PersonalInfoForm: React.FC<PersonalInfoFormProps> = ({
    model,
    onSuccess,
    onCancel,
}: PersonalInfoFormProps) => {
    return (
        <React.Fragment>
            <Formik<PersonalInfo>
                initialValues={model}
                onSubmit={onSuccess}
                render={props => (
                    <form>
                        <div className={styles.formContainer}>
                            <div className={styles.fieldsContainer}>
                                <div className={styles.firstColumn}>
                                    <div className={styles.radioLabel}>Civilité*</div>
                                    <RadioInputControl name="civility" required horizontal options={CivilityList} />
                                    <div className={styles.label}>Votre nom*</div>
                                    <InputControl name="lastName" placeholder="Nom" required />
                                    <div className={styles.label}>Votre prénom*</div>
                                    <InputControl name="firstName" placeholder="Prénom" required />
                                    <div className={styles.label}>Date de Naissance*</div>
                                    <DatePickerControl name="birthDate" minAgeRequired={18} required />
                                    <div className={styles.label}>Votre téléphone mobile*</div>
                                    <PhoneInputControl name="phoneNumber" placeholder="Numéro de téléphone" required />
                                    <div className={styles.label}>Votre adresse email*</div>
                                    <EmailInputControl name="email" placeholder="Email" required />
                                </div>

                                <div className={styles.secondColumn}>
                                    <div className={styles.label}>Adresse*</div>
                                    <InputControl name="address" placeholder="Adresse" required />

                                    <div className={styles.label}>Complément d&apos;adresse</div>
                                    <InputControl name="complement" placeholder="Complément" />

                                    <div className={styles.label}>Code postal*</div>
                                    <InputControl name="zipCode" placeholder="Code postal" required />

                                    <div className={styles.label}>Ville*</div>
                                    <InputControl name="city" placeholder="Ville" required />

                                    <div className={styles.label}>Pays*</div>
                                    <InputControl name="country" placeholder="Pays" required />

                                    <div className={styles.radioLabel}>
                                        Je souhaite être informé de l&apos;actualité Printemps Listes
                                    </div>
                                    <RadioInputControl
                                        name="newsletter"
                                        horizontal
                                        options={[
                                            { value: 1, text: 'Oui' },
                                            { value: 0, text: 'Non' },
                                        ]}
                                    />

                                    <div className={styles.radioLabel}>
                                        Pensez-vous ouvrir une liste de Mariage au Printemps ?
                                    </div>
                                    <RadioInputControl
                                        name="openWeddingList"
                                        horizontal
                                        options={[
                                            { value: 1, text: 'Oui' },
                                            { value: 0, text: 'Non' },
                                        ]}
                                    />

                                    <div className={styles.radioLabel}>
                                        Souhaitez-vous être recontacté au cas où un rendez-vous d&apos;essayage se
                                        libère plus tôt ?
                                    </div>
                                    <RadioInputControl
                                        name="contactIfSlotAvailable"
                                        horizontal
                                        options={[
                                            { value: 1, text: 'Oui' },
                                            { value: 0, text: 'Non' },
                                        ]}
                                    />
                                </div>
                            </div>

                            <div className={styles.buttonsContainer}>
                                <div className={styles.backButton}>
                                    <ClassicButton text="PRÉCÉDENT" onClick={onCancel} />
                                </div>
                                <div className={styles.validateButton}>
                                    <ClassicButton
                                        text="VALIDER VOTRE RENDEZ-VOUS"
                                        onClick={props.submitForm}
                                        disabled={!props.isValid}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            />
        </React.Fragment>
    );
};
